import React, { Component } from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'
import InstagramImage from '../../assets/images/instagram.png'

class Footer extends Component {
  render() {
    return (
      <div className="ch-footer">
        <div style={{ borderBottom: '1px solid #4b4e53' }}>
          <div className="ch-footer-link col-10 offset-1 pt-5">
            <div className="row">
              <div
                className="col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 col-xl-2 offset-xl-4 d-flex mb-5"
                style={{ flexDirection: 'column' }}
              >
                <p>
                  <Link to="/#home" smooth>
                    Chef Hung
                  </Link>
                </p>
                <p>
                  <Link to="/promotion-detail">โปรโมชั่น</Link>
                </p>
                <p>
                  <Link to="/product-detail">สินค้า</Link>
                </p>
                {/* FIXME */}
                {/* <p>
                  <Link to="/#about" smooth>
                    เกี่ยวกับเรา
                  </Link>
                </p> */}
                <p>
                  <Link to="/contact-detail">ที่ตั้ง & สาขา</Link>
                </p>
              </div>
              <div className="col-12 col-md-4 col-lg-3 col-xl-2 mb-5">
                <p>
                  <FontAwesomeIcon icon="phone" />
                  <span>081-806-2929</span>
                </p>
                <p>
                  <FontAwesomeIcon icon="envelope" />
                  <span>example@company.com</span>
                </p>
                <a
                  className="mt-2"
                  href="https://www.instagram.com/chefhung.bkk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={InstagramImage} alt="chefhung.bkk" />
                  <span>chefhung.bkk</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 py-2">
          <p className="m-0 text-center">
            © 2020 Published by Arbhorn Foods Ltd. All Rights Reserved.
          </p>
        </div>
      </div>
    )
  }
}

export default Footer
